import { createFileRoute } from '@tanstack/react-router'

import { WeeklyTrendsScreen } from './-components/weekly-trends-screen.tsx'

export const Route = createFileRoute('/business-performance/weekly-trends')({
  component: WeeklyTrendsScreen
})
